import React, { useMemo, useRef } from 'react'
import SetupTab from 'modules/setup/setupTab/SetupTab'
import { TextBox, Label, RemoveModal } from 'components'
import { Row, Col, FormGroup } from 'react-bootstrap'
import { fetchUrl } from 'modules/util/functions'
import { useSetupTabValueContext, useSetupTabActionsContext } from 'modules/setup/setupTab/SetupTabContext'

const RotacionSincronicaInfoTab = () => {
	const { selectedId, form } = useSetupTabValueContext();
	const { onDelete, onError, onSuccess } = useSetupTabActionsContext();
	const _removeModal = useRef();

	const configuration = useMemo(() => ({
		urls: {
			get: "/rotacionSincronicaSetup/getRotacionSincronicaInfo",
			save: "/rotacionSincronicaSetup/saveRotacionSincronicaInfo",
			create: "/rotacionSincronicaSetup/createRotacionSincronica"
		},
		getRequest: () => {
			return {
				idRotacionSincronica: selectedId
			}
		},
		saveRequest: (form) => {
			return {
				idRotacionSincronica: selectedId,
				nombre: form.nombre
			}
		}
	}), [selectedId]);

	const actions = [{
		key: "delete",
		name: "Borrar",
		onClick: () => {
			handleDelete();
		}
	}];

	// Handlers
	const handleDelete = () => {
		const rq = {
			idRotacionSincronica: selectedId
		};

		_removeModal.current.open({
			title: "Eliminando rotacionSincronica",
			name: form.nombre,
			onYes: () => {
				fetchUrl("/rotacionSincronicaSetup/deleteRotacionSincronica", "post", rq, {
					success: (r) => {
						onSuccess(r.message);
						onDelete();
					},
					error: (r) => {
						onError(r.errorMessage);
					}
				}, { block: false });
			}
		});
	}

	return (
		<React.Fragment>
			<RemoveModal
				ref={_removeModal} />

			<SetupTab
				configuration={configuration}
				actions={actions}>
				<Row>
					<Col md={4}>
						<FormGroup>
							<Label required>Nombre</Label>
							<TextBox
								name="nombre"
								placeholder="Nombre" />
						</FormGroup>
					</Col>
				</Row>
			</SetupTab>
		</React.Fragment>
	)
}

export default RotacionSincronicaInfoTab;